import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {genericErrorHasOccurred} from '../../../actions/generic-error/action-creators';
import propLoaders from '../../../prop-loaders';
import {
    getCsrf, getGenericError, getLanguageCode, getTranslations
} from '../../../utils/selectors';
import Spinner from '../../atoms/Spinner';
import {CreditCardSection} from '../../organisms';
import {useTabapayConfirmation} from './tabapay-confirmation.hooks';

export const TabapayConfirmation = ({
    dispatch,
    languageCode,
    translations,
    csrfToken,
    genericError,
    cardDetails: initCardDetails,
    error: initError,
    match
}) => {
    const paymentSessionId = match.params.sessionId;

    const {isSubmitting, onSubmit, cardDetails} = useTabapayConfirmation({
        languageCode,
        paymentSessionId,
        csrfToken,
        dispatch,
        initError,
        initCardDetails
    });

    if (!cardDetails) {
        return <Spinner styles={{minHeight: 300, height: 'auto'}} />;
    }

    return (
        <CreditCardSection
            showCancelButton
            isSubmitting={isSubmitting}
            genericError={genericError}
            translations={translations}
            maskedCardNumber={cardDetails?.maskedCardNumber}
            onSubmit={onSubmit}
            languageCode={languageCode}
        />
    );
};


TabapayConfirmation.getServerSideProps = async (context, store) => {
    try {
        const {requestId, sessionId, params: {sessionId: paymentSessionId}} = context;
        const cardDetails = await propLoaders.getTabapayCardDetails(
            {requestId, sessionId, query: {paymentSessionId}}
        );
        return {cardDetails};
    } catch (error) {
        store.dispatch(genericErrorHasOccurred(true));
        return {
            cardDetails: null,
            error
        };
    }
};

TabapayConfirmation.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            sessionId: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    translations: PropTypes.shape().isRequired,
    csrfToken: PropTypes.string.isRequired,
    genericError: PropTypes.bool,
    cardDetails: PropTypes.shape({
        maskedCardNumber: PropTypes.string,
        expirationDate: PropTypes.string,
        cardType: PropTypes.string
    }),
    error: PropTypes.shape()
};

TabapayConfirmation.defaultProps = {
    genericError: null,
    cardDetails: null,
    error: null
};

const mapStateToProps = state => ({
    genericError: getGenericError(state),
    translations: getTranslations(state),
    languageCode: getLanguageCode(state),
    csrfToken: getCsrf(state)
});

export default connect(mapStateToProps)(TabapayConfirmation);
